import React from 'react';
import {
  Box,
  Card,
  CardContent,
  Alert,
} from '@mui/material';
import { useAuthStore } from '../store/authStore';
import { AccountType } from '../types/auth';
import PageHeader from '../components/common/PageHeader';
import XmlApiForm from '../components/xml-api/XmlApiForm';

const XmlApiPage: React.FC = () => {
  const { user } = useAuthStore();

  // Only Master Admins can access this page
  if (user?.accountType! < AccountType.User) {
    return (
      <Box>
        <Alert severity="error">
          Access denied. This feature is only available to Master Administrators.
        </Alert>
      </Box>
    );
  }

  return (
    <Box>
      <PageHeader description="Test XML API requests against your account and inspect responses." />
      <Card>
        <CardContent>
          <XmlApiForm />
        </CardContent>
      </Card>
    </Box>
  );
};

export default XmlApiPage;